import { Capacitor } from "@capacitor/core";

/** Matches `useIsMobile`'s breakpoint, so the two agree on what counts as a phone viewport. */
const MOBILE_MAX_WIDTH = 768;

/**
 * Whether this platform paints a PDF inside an `<iframe src="blob:…">`.
 *
 * Desktop browsers do. Capacitor's WKWebView and the Android WebView do NOT — they render a blank
 * frame with no error at all, which is worse than an honest "download to view" message. Mobile
 * Safari hands the URL to a download instead of rendering it.
 *
 * Exported so a caller can also skip *building* the document, not just skip showing it.
 */
export const supportsInlinePdfPreview = (): boolean => !Capacitor.isNativePlatform() && window.innerWidth > MOBILE_MAX_WIDTH;
